module.exports = __webpack_public_path__ + "img/setup_guidline3.4be73023.png";